import React, {ComponentType, useState, useEffect} from 'react';
import {useParams} from 'react-router-dom';
import {Player} from "~/types/player";
import {PlayerProfile, PlayerProfileProps} from "~/pages/player-profile/PlayerProfile";

import {playerEleea} from "~/pages/player-profile/mock-data";

// Mock API call (replace with your actual API)
const fetchPlayerData = async (id: string): Promise<Player> => {
    // Simulated API call
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(playerEleea);
        }, 1000);
    });
};

export const withPlayerData = <P extends PlayerProfileProps>(
    WrappedComponent: ComponentType<P>
) => {
    const WithPlayerData: React.FC<Omit<P, 'player' | 'loading' | 'error'>> = (props) => {
        const {id, affiliation, sport} = useParams<{ id: string, affiliation: string, sport: string }>();
        const [player, setPlayer] = useState<Player | null>(null);
        const [loading, setLoading] = useState(true);
        const [error, setError] = useState<string | null>(null);

        useEffect(() => {
            const loadPlayer = async () => {
                if (!id) {
                    setError("No player ID provided");
                    setLoading(false);
                    return;
                }

                try {
                    setLoading(true);
                    const data = await fetchPlayerData(id);
                    setPlayer(data);
                    setError(null);
                } catch (err) {
                    setError("Failed to load player data");
                } finally {
                    setLoading(false);
                }
            };

            loadPlayer().then(r => console.log(r));
        }, [id]);

        return (
            <WrappedComponent
                {...(props as P)}
                player={player}
                affiliation={affiliation}
                sport={sport}
                loading={loading}
                error={error}
            />
        );
    };

    return WithPlayerData;
};

export default withPlayerData(PlayerProfile)